import * as React from 'react';
import { IconButton } from '@naan/primitives/button';
import { observer } from 'mobx-react-lite';
import { Story } from '@core/models/story-manager';
import { styled } from '@naan/stitches.config';
import { useReaction } from '@common/hooks/use-reaction';
import { AppFactory } from 'app/app-factory';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftSmallIcon } from '@naan/icons/arrow-left-icon';
import { ReturnNavState } from 'components/nav/return-nav-state';
import { homePath } from 'components/nav/path-helpers';
import { headerColors } from 'components/soundbites/soundbite-headers';
import { SoundbiteCategory } from 'components/soundbites/soundbite-categories';
import { soundbitePlayerUiModel } from 'soundbite/fx/soundbite-player-ui-model';
import { MarkSimple } from '@naan/primitives/text';
// import { colors } from '@naan/tokens/colors';
import { SoundbiteHelpDialog } from 'components/soundbites/soundbite-welcome-dialog';
import { usePlayerModel } from 'player/views/player-model-context';

const Wrapper = styled('div', {
  $$backgroundColor: '$colors$white',

  position: 'absolute',
  top: '0',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '56px',
  padding: '0 8px',
  flexShrink: '0',
  // background: '$$backgroundColor',
  background: 'transparent',
  zIndex: '2',
  transition: 'transform .3s, background .3s',
  color: '$white',

  '& > .left': {
    position: 'absolute',
    left: '8px',
  },
  '& > .title': {
    textStyle: 'body-bold',
    transition: 'opacity .3s',
    opacity: 0,
  },
  '& > .right': {
    position: 'absolute',
    right: '8px',
  },

  '& > .date': {
    display: 'none',
    '@playerSmallAndUp': {
      display: 'block',
    },
  },

  '&.playing': {
    transform: 'translateY(-100%)',
    // $$backgroundColor: paletteKey('$$script__backgroundColor_playing'),
  },

  '&.showing-title': {
    background: '$$backgroundColor',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
    '& .title': {
      // transition: 'opacity .3s',
      opacity: 1,
    },
  },
});

const Back = () => {
  const navigate = useNavigate();

  // return <Logo />;

  return (
    <IconButton
      icon={<ArrowLeftSmallIcon />}
      presentation="whiteTransparent"
      noFocus
      tabIndex={-1}
      onClick={() => {
        if (ReturnNavState.canPopFromStudy()) {
          navigate(-1);
        } else {
          navigate(homePath());
        }
      }}
      testId="soundbite-back-button"
    />
  );
};

export const SbHeader = observer(({ story }: { story: Story }) => {
  const playerModel = usePlayerModel();
  const ref = React.useRef<HTMLDivElement>(null);
  // never automatically opened since we now have the orientation interstitial
  // const autoShowWelcomeDialog = false; //playerModel.onloadModalNeeded;

  const soundbiteModel = AppFactory.soundbiteModel;
  const soundbite = soundbiteModel.soundbite;
  const category = soundbite?.category as SoundbiteCategory;

  const $$backgroundColor = headerColors[category];

  useReaction(
    () => playerModel.isPlaying,
    () => {
      if (playerModel.isPlaying) {
        ref.current?.classList.add('playing');
      } else {
        ref.current?.classList.remove('playing');
      }
    }
  );

  useReaction(
    () => soundbitePlayerUiModel.showTitleInHeader,
    showing => {
      if (showing) {
        ref.current?.classList.add('showing-title');
      } else {
        ref.current?.classList.remove('showing-title');
      }
    }
  );

  return (
    <Wrapper css={{ $$backgroundColor }} ref={ref}>
      <span className="left">
        <Back />
      </span>
      <span className="title">
        <MarkSimple source={soundbite?.title} />
      </span>
      <span className="right">
        <SoundbiteHelpDialog />
      </span>
    </Wrapper>
  );
});
